import { render, staticRenderFns } from "./DateTimeWidget.vue?vue&type=template&id=20328fb8&scoped=true&"
import script from "./DateTimeWidget.vue?vue&type=script&lang=js&"
export * from "./DateTimeWidget.vue?vue&type=script&lang=js&"
import style0 from "./DateTimeWidget.vue?vue&type=style&index=0&id=20328fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20328fb8",
  null
  
)

export default component.exports